import React from 'react';
import IOSCircuitLoader from '../pages/service-landing-hub/components/IOSCircuitLoader';

/**
 * Reusable loading fallback component for React.Suspense
 * Uses the iOS-style loader for consistency across the app
 */
const LoadingFallback = () => {
    return (
        <div className="min-h-screen bg-[#FBFBFD] flex items-center justify-center">
            <IOSCircuitLoader />
        </div>
    );
};

export default LoadingFallback;
